import { useTranslation } from "react-i18next";
import React from "react";
import { Tooltip } from "@mui/material";
import { useFeature } from "../hooks";

const CargoQualitiesAndDemandsTooltip = (props: {
  cargo: {
    qualities: string[];
    requirements: string[];
  };
  children: React.ReactNode;
}) => {
  const { t } = useTranslation("types");
  const isFeatureEnabled = useFeature("cargo-requirements-demands-tooltip");

  if (!isFeatureEnabled) {
    return <>{props.children}</>;
  }

  const qualities = props.cargo.qualities
    .map((q) => t(`types:cargoQualities.type` as any, { context: q }))
    .join(", ");

  const requirements = props.cargo.requirements
    .map((q) => t(`trailerQualities.type` as any, { context: q }))
    .join(", ");

  return (
    <Tooltip
      title={
        qualities.length || requirements.length ? (
          <div>
            {qualities.length && <div>{qualities}</div>}
            {requirements && <div>{requirements}</div>}
          </div>
        ) : null
      }
      placement="top"
    >
      {props.children as any}
    </Tooltip>
  );
};

export default CargoQualitiesAndDemandsTooltip;
